import React, { useState } from 'react'
import {
	AccordionList,
	Accordion,
	Header,
	Title,
	AccordionToggle,
	Editor,
	Collapse,
} from './style'
import { Icon } from '../Icon'
import ReactHtmlParser from 'react-html-parser'

const Accordions = ({ list }) => {
	const [isOpen, setIsOpen] = useState({
		idx: null,
		status: true,
	})

	const toggle = (idx) => {
		if (idx === isOpen.idx && isOpen.status) {
			setIsOpen({
				idx,
				status: false,
			})
		} else {
			setIsOpen({
				idx,
				status: true,
			})
		}
	}

	return (
		<AccordionList>
			{list?.map((item, idx) => (
				<Accordion key={idx}>
					<Header onClick={() => toggle(idx)}>
						<AccordionToggle>
							<Icon
								component={
									idx === isOpen.idx && isOpen.status
										? 'minusRadial'
										: 'plusRadial'
								}
							/>
						</AccordionToggle>
						<Title>{item.title}</Title>
					</Header>
					<Collapse isOpen={idx === isOpen.idx && isOpen.status}>
						<Editor>{ReactHtmlParser(item.text)}</Editor>
					</Collapse>
				</Accordion>
			))}
		</AccordionList>
	)
}
export default Accordions
